import React from "react";
import Box from '@mui/material/Box';
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { WEB_URL } from "../../api/URLs";
import { GTM_EVENTS } from "../../constants";
import { StyledBox, StyledContainer } from "./styles";
import { Footer, Header, GetInspiredCards, MixPanelTrackedLink } from "../../components";

export default function AboutUs() {
    return <Box className="AboutUsPage">
        <Header />
        <StyledContainer>
            <Stack className="IntroSection" direction={{ xs: 'column', md: 'row' }}
                spacing={{ xs: 4, sm: 6 }}>
                <LazyLoadImage
                    src={'https://cdn.tcfglobal.org/fundraiser-page-default-images/April2022/IQYJf9IHzpNmACLTi5Ik.jpg'}
                    effect="blur"
                />
                <Stack spacing={2} justifyContent="center">
                    <Typography variant="h4" gutterBottom>About The Citizens Foundation</Typography>
                    <Typography>
                        The Citizens Foundation (TCF) is a professionally managed non-profit organization set up in 1995 by a
                        group of citizens who want to bring about positive social change through education. Today, TCF is one
                        of Pakistan’s leading organizations in the field of education, with over 280,000 children enrolled in its
                        1,833 schools built to cater to the most deprived communities in Pakistan.
                    </Typography>
                    <Typography>
                        The TCF school curriculum promotes an interactive, child centered teaching approach with emphasis on
                        hands-on activities that help children learn, question and enjoy the education process. Through the power
                        of quality education TCF is enabling moral, spiritual and intellectual enlightenment of Pakistan's
                        children.
                    </Typography>
                </Stack>
            </Stack>

            <Box className="Section2">
                <Typography variant="h5" gutterBottom>You can be a part of this journey!</Typography>
                <Typography className="Section2Desc">
                    You can create a fundraiser of your own or contribute to an existing fundraiser to help achieve a goal.
                    <br /><br />
                    With TCF Global you can:
                </Typography>
                <Stack className="BulletPointsContainer" direction={{ xs: 'column', md: 'row' }} justifyContent="space-between">
                    <Box sx={{ p: 1 }}>
                        <Typography sx={{ marginBottom: '20px' }} className="BoldHeading" gutterBottom>Fundraise for Education</Typography>
                        <ul>
                            <li>
                                <Typography gutterBottom>
                                    Share your story with other supporters across the world
                                </Typography>
                            </li>
                            <li>
                                <Typography gutterBottom>
                                    Set a fundraising goal from a range of currencies
                                </Typography>
                            </li>
                            <li>
                                <Typography gutterBottom>
                                    Post pictures, videos and updates about your fundraiser
                                </Typography>
                            </li>
                        </ul>
                    </Box>
                    <Box sx={{ p: 1 }}>
                        <Typography sx={{ marginBottom: '20px' }} className="BoldHeading" gutterBottom>Share your Fundraiser</Typography>
                        <ul>
                            <li>
                                <Typography gutterBottom>
                                    Share your fundraiser with friends and family all over the world
                                </Typography>
                            </li>
                            <li>
                                <Typography gutterBottom>
                                    Encourage support by sharing your fundraiser on your social media
                                </Typography>
                            </li>
                        </ul>
                    </Box>
                    <Box sx={{ p: 1 }}>
                        <Typography sx={{ marginBottom: '20px' }} className="BoldHeading" gutterBottom>Donating for Education</Typography>
                        <ul>
                            <li>
                                <Typography gutterBottom>
                                    Browse through existing fundraisers
                                </Typography>
                            </li>
                            <li>
                                <Typography gutterBottom>
                                    Donate to the fundraiser of your choice in multiple currencies and payment methods
                                </Typography>
                            </li>
                        </ul>
                    </Box>
                </Stack>
            </Box>

            <Stack spacing={6} alignItems="center">
                <Box>
                    <Typography variant="h5" align="center" gutterBottom>Get inspired!</Typography>
                    <Typography align="center" gutterBottom>Here’s how our amazing supporters from around the world are raising funds to support education in Pakistan!</Typography>
                    {/* <Typography align="center" gutterBottom>You too can choose to do anything to show your support for education.</Typography> */}
                    <Typography align="center">The sky is the limit in showing your support for education!</Typography>
                </Box>
                <GetInspiredCards />
                <Stack direction="column" alignItems="center" spacing={2} >
                    <Typography variant="h5" align="center">How will you fundraise for education?</Typography>
                    <MixPanelTrackedLink className="StartYourFundraiserButton" type="button" gtmEvent={GTM_EVENTS.START_FUNDRAISER_CLICKED} href={WEB_URL.CREATE_FUNDRAISER} label="Start Your Fundraiser" context="About us page" variant="contained" sx={{ width: '200px', whiteSpace: 'nowrap' }}>START YOUR FUNDRAISER</MixPanelTrackedLink>

                    <MixPanelTrackedLink gtmEvent={GTM_EVENTS.SUPPORT_FUNDRAISER_CLICKED} href={WEB_URL.FUNDRAISER_LISTING} type="link" label="Or find an existing fundraiser" context="About us page">Or find an existing fundraiser</MixPanelTrackedLink>
                </Stack>
            </Stack>
        </StyledContainer>
        <StyledBox className="MoreQuestionsSection">
            <Container>
                <Typography variant="h5" gutterBottom>Have more questions?</Typography>
                <Typography>
                    We are happy to answer! <MixPanelTrackedLink href={WEB_URL.FAQS} type="link" label="Click here" context="About us page">Click here</MixPanelTrackedLink> to visit
                    our FAQ page for more details and if you can’t find your answer there, please reach out at <a href="mailto:contact@tcfglobal.org">contact@tcfglobal.org</a>
                </Typography>
            </Container>
        </StyledBox>
        <Footer />
    </ Box>
}